import React, { useState } from 'react';
import { Input, Label, Modal, Button, ModalHeader, ModalFooter, ModalBody, FormGroup, Form } from "reactstrap";
import {sendNotificationApi} from '../services/Device'

const NotifyModel = ({ notificationModel, setNotificationModel, toggle, notifyDetails }) => {
  const [title, setTitle ] = useState('Fempulse');
  const [msg, setMsg ] = useState('Welcome to Fempulse');

  const handleClose = () => setNotificationModel(false);
  
    const handleOnSendPushNotification = async () => {
      if(notifyDetails.token){
        let detailsObj = {
          to: notifyDetails.token,
          "notification": {
            title: title,
            body:msg,
            "content_available" : true,
            "priority": "high",
          }
        }
        await sendNotificationApi(detailsObj);
        handleClose();
      }
    }
    return (<>
      <Modal
        isOpen={notificationModel} toggle={toggle}>
        <ModalHeader >
          <a style={{ fontSize: 'large' }}>Create Notification </a>
        </ModalHeader>
        <ModalBody>
          <Form >
            <FormGroup >
              <Label className="floating-label" htmlFor="title">Title</Label>
              <Input
                // value={title}
                onChange={(e)=>{setTitle(e.target.value)}}
                type="text"
                name="title"
                className="form-control-alternative"
                id="categoryCode"
                defaultValue={title}
                placeholder="Enter Title"
                required="" />
            </FormGroup>
            <FormGroup >
              <Label className="floating-label" htmlFor="message">Message</Label>
              <Input
                // value={msg}
                defaultValue={msg}
                onChange={(e)=>{setMsg(e.target.value)}}
                type="textarea"
                name="message"
                rows="5"
                className="form-control-alternative"
                id="message"
                placeholder="Enter Message"
              />
            </FormGroup>
            {/* <FormGroup >
              <Label className="floating-label" htmlFor="image">Image Link</Label>
              <Input
                type="text"
                name="image"
                className="form-control-alternative"
                id="image"
                placeholder="Enter Image Link"
                required="" />
            </FormGroup> */}
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button style={{ backgroundColor: "#CFD2D8" }} variant="primary" onClick={handleOnSendPushNotification}>
            Submit
          </Button>
        </ModalFooter>
      </Modal>
    </>)
  }
  export default NotifyModel;